import React, { ButtonHTMLAttributes, FC } from 'react';
import styles from './Button.module.scss';
import { ButtonFormats, ButtonSizes, IconNames } from '@/components/UI/Types';
import Icon from '@/components/UI/icon/Icon';
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  format: ButtonFormats;
  size?: ButtonSizes;
  startIcon?: IconNames;
  endIcon?: IconNames;
  disabled?: boolean;
  loading?: boolean;
  data_cy?: string;
  className?: string;
}
const Button: FC<ButtonProps> = ({
  children,
  format,
  type = 'button',
  size = 'medium',
  startIcon,
  endIcon,
  disabled,
  loading = false,
  data_cy,
  className = '',
  ...props
}) => {
  return <button {...props} disabled={disabled || loading} type={type} className={styles['button-class'] + ' ' + styles[`${format}`] + ' ' + styles[`${size}`] + ' ' + `${loading ? styles['loading'] : ''}` + ' ' + className} data-cy={data_cy} data-sentry-component="Button" data-sentry-source-file="Button.tsx">
      {!loading && <>
          {startIcon && <Icon type={'inherit'} size={size} name={startIcon} />}
          {children}
          {endIcon && <Icon type={'inherit'} size={size} name={endIcon} />}
        </>}
    </button>;
};
export default Button;